<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Nachschreibeklausuren</v-card-title>
      <v-tabs v-model="tab">
        <v-tab>Meine Nachschreiber</v-tab>
        <v-tab>Nachschreibetermin</v-tab>
      </v-tabs>
    </v-card>
    <br>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <my-missing-exams/>
      </v-tab-item>
      <v-tab-item>
        <retake-attendance/>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import MyMissingExams from "@/components/missingExams/MyMissingExams.vue";
import RetakeAttendance from "@/components/missingExams/RetakeAttendance.vue";

@Component({
  components: {MyMissingExams, RetakeAttendance},
})
export default class MissingExams extends Vue {
  private tab = 0
}
</script>
